import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer, BarChart, Bar, Cell } from 'recharts';
import { Info, Edit2, AlertCircle, CheckCircle2, TrendingUp } from 'lucide-react';
const trafficData = [{
  date: 'Nov 21',
  control: 0,
  variant: 0
}, {
  date: 'Nov 23',
  control: 12,
  variant: 14
}, {
  date: 'Nov 25',
  control: 30,
  variant: 36
}, {
  date: 'Nov 27',
  control: 48,
  variant: 55
}, {
  date: 'Nov 29',
  control: 65,
  variant: 75
}, {
  date: 'Dec 1',
  control: 90,
  variant: 105
}, {
  date: 'Dec 3',
  control: 120,
  variant: 140
}, {
  date: 'Dec 5',
  control: 148,
  variant: 172
}, {
  date: 'Dec 7',
  control: 178,
  variant: 208
}, {
  date: 'Dec 9',
  control: 208,
  variant: 240
}, {
  date: 'Dec 11',
  control: 233,
  variant: 268
}];
const conversionData = [{
  name: 'Control',
  rate: 49.05,
  fill: '#1B3A4B'
}, {
  name: 'Variant',
  rate: 56.42,
  fill: '#1A8B9D'
}];
export function ExperimentDashboard() {
  return <div className="p-8 max-w-7xl mx-auto space-y-6" data-id="element-7">
      {/* Header Section */}
      <div data-id="element-8">
        <h2 className="text-2xl font-bold text-slate-800 mb-1" data-id="element-9">
          FY26 EOY Donation Form Test - Dynamic Content & Messaging
        </h2>
        <p className="text-slate-500" data-id="element-10">
          Experiment Results — Purchase Conversion
        </p>
      </div>

      {/* Status Banner */}
      <div className="bg-teal-50 border border-teal-100 rounded-lg p-4 flex items-center justify-between" data-id="element-11">
        <div className="flex items-center gap-3" data-id="element-12">
          <CheckCircle2 className="text-teal-600" size={24} data-id="element-13" />
          <div data-id="element-14">
            <div className="flex items-center gap-3" data-id="element-15">
              <h3 className="font-semibold text-teal-900 text-lg" data-id="element-16">
                Experiment Stopped
              </h3>
              <span className="bg-teal-500 text-white text-xs font-bold px-2.5 py-1 rounded-full uppercase tracking-wide" data-id="element-17">
                Conclusive
              </span>
            </div>
            <p className="text-teal-700 text-sm mt-0.5" data-id="element-18">
              Variant outperformed Control with 95.3% confidence.
            </p>
          </div>
        </div>
        <button className="text-teal-600 hover:text-teal-800 p-2 rounded-full hover:bg-teal-100 transition-colors" data-id="element-19">
          <Edit2 size={18} data-id="element-20" />
        </button>
      </div>

      {/* Settings Row */}
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-600 bg-white p-4 rounded-lg border border-slate-200 shadow-sm" data-id="element-21">
        <div className="flex items-center gap-2" data-id="element-22">
          <span className="font-semibold text-slate-700" data-id="element-23">Engine:</span> Bayesian
        </div>
        <div className="flex items-center gap-2" data-id="element-24">
          <span className="font-semibold text-slate-700" data-id="element-25">CUPED:</span> Disabled
        </div>
        <div className="flex items-center gap-2" data-id="element-26">
          <span className="font-semibold text-slate-700" data-id="element-27">
            Post-Stratification:
          </span>{' '}
          Disabled
        </div>
        <div className="flex items-center gap-2" data-id="element-28">
          <span className="font-semibold text-slate-700" data-id="element-29">Anonymous IDs:</span>{' '}
          950
        </div>
        <div className="flex items-center gap-2 ml-auto text-slate-500" data-id="element-30">
          Nov 21 – Dec 11, 2025
        </div>
      </div>

      {/* Key Metrics Summary Cards */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-31">
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-center" data-id="element-32">
          <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-33">
            Total Users
          </div>
          <div className="text-2xl font-bold text-slate-800" data-id="element-34">950</div>
        </div>
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-center" data-id="element-35">
          <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-36">
            Control Conv.
          </div>
          <div className="text-2xl font-bold text-slate-800" data-id="element-37">49.05%</div>
        </div>
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-center" data-id="element-38">
          <div className="text-xs font-bold text-teal-600 uppercase tracking-wider mb-1" data-id="element-39">
            Variant Conv.
          </div>
          <div className="text-2xl font-bold text-teal-700" data-id="element-40">56.42%</div>
        </div>
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-center" data-id="element-41">
          <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-42">
            Lift
          </div>
          <div className="text-2xl font-bold text-green-600 flex items-center gap-1" data-id="element-43">
            <TrendingUp size={20} data-id="element-44" />
            +15.0%
          </div>
        </div>
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-center" data-id="element-45">
          <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-46">
            Confidence
          </div>
          <div className="text-2xl font-bold text-slate-800" data-id="element-47">95.3%</div>
        </div>
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-center items-center text-center" data-id="element-48">
          <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2" data-id="element-49">
            Status
          </div>
          <div className="flex items-center gap-1.5 text-teal-600 font-semibold bg-teal-50 px-3 py-1 rounded-full" data-id="element-50">
            <CheckCircle2 size={16} data-id="element-51" />
            Winner
          </div>
        </div>
      </div>

      {/* Goal Metrics Table */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-52">
        <div className="px-6 py-4 border-b border-slate-200 flex justify-between items-center bg-slate-50/50" data-id="element-53">
          <h3 className="font-semibold text-slate-800 flex items-center gap-2" data-id="element-54">
            Goal Metrics
            <Edit2 size={14} className="text-slate-400 cursor-pointer hover:text-slate-600" data-id="element-55" />
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-56">
          <table className="w-full text-sm text-left" data-id="element-57">
            <thead className="text-xs text-slate-500 bg-white border-b border-slate-200" data-id="element-58">
              <tr data-id="element-59">
                <th className="px-6 py-4 font-semibold" data-id="element-60">Metric</th>
                <th className="px-6 py-4 font-semibold" data-id="element-61">
                  <div className="flex items-center gap-1.5" data-id="element-62">
                    <span className="w-4 h-4 rounded-full border-2 border-slate-300 flex items-center justify-center text-[9px] text-slate-500" data-id="element-63">
                      0
                    </span>
                    Control
                  </div>
                </th>
                <th className="px-6 py-4 font-semibold" data-id="element-64">
                  <div className="flex items-center gap-1.5 text-teal-700" data-id="element-65">
                    <span className="w-4 h-4 rounded-full bg-teal-100 border border-teal-300 flex items-center justify-center text-[9px] font-bold" data-id="element-66">
                      1
                    </span>
                    Variant
                  </div>
                </th>
                <th className="px-6 py-4 font-semibold" data-id="element-67">Chance to Win</th>
                <th className="px-6 py-4 font-semibold text-right" data-id="element-68">% Change</th>
              </tr>
            </thead>
            <tbody data-id="element-69">
              <tr className="hover:bg-slate-50 transition-colors" data-id="element-70">
                <td className="px-6 py-5 font-medium text-slate-800" data-id="element-71">
                  purchase
                </td>
                <td className="px-6 py-5" data-id="element-72">
                  <div className="font-semibold text-slate-800" data-id="element-73">49.05%</div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-74">233 / 475</div>
                </td>
                <td className="px-6 py-5" data-id="element-75">
                  <div className="font-semibold text-teal-700" data-id="element-76">56.42%</div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-77">268 / 475</div>
                </td>
                <td className="px-6 py-5" data-id="element-78">
                  <div className="flex items-center gap-3" data-id="element-79">
                    <div className="w-32 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-80">
                      <div className="h-full bg-teal-500 rounded-full" style={{
                      width: '95.3%'
                    }} data-id="element-81"></div>
                    </div>
                    <span className="font-medium text-slate-700" data-id="element-82">95.3%</span>
                  </div>
                </td>
                <td className="px-6 py-5 text-right" data-id="element-83">
                  <span className="inline-flex items-center gap-1 text-green-600 font-semibold bg-green-50 px-2.5 py-1 rounded-md" data-id="element-84">
                    <TrendingUp size={14} data-id="element-85" />
                    +15.0%
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-86">
        {/* Traffic Over Time */}
        <div className="lg:col-span-2 bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-87">
          <div className="flex justify-between items-start mb-6" data-id="element-88">
            <div data-id="element-89">
              <h3 className="font-semibold text-slate-800 text-lg" data-id="element-90">
                Experiment Conversions Over Time
              </h3>
              <p className="text-sm text-slate-500 mt-1" data-id="element-91">
                Cumulative conversions across variations
              </p>
            </div>
            <div className="flex items-center gap-4 text-sm" data-id="element-92">
              <div className="flex items-center gap-2" data-id="element-93">
                <div className="w-3 h-3 bg-[#1B3A4B] rounded-sm" data-id="element-94"></div>
                <span className="text-slate-600" data-id="element-95">Control</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-96">
                <div className="w-3 h-3 bg-[#1A8B9D] rounded-sm" data-id="element-97"></div>
                <span className="text-slate-600" data-id="element-98">Variant</span>
              </div>
            </div>
          </div>

          <div className="h-72 w-full" data-id="element-99">
            <ResponsiveContainer width="100%" height="100%" data-id="element-100">
              <LineChart data={trafficData} margin={{
              top: 5,
              right: 20,
              bottom: 5,
              left: 0
            }} data-id="element-101">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" data-id="element-102" />
                <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{
                fill: '#64748b',
                fontSize: 12
              }} dy={10} data-id="element-103" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748b',
                fontSize: 12
              }} dx={-10} data-id="element-104" />
                <RechartsTooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-105" />
                <Line type="monotone" dataKey="control" name="Control" stroke="#1B3A4B" strokeWidth={2} dot={false} activeDot={{
                r: 6
              }} data-id="element-106" />
                <Line type="monotone" dataKey="variant" name="Variant" stroke="#1A8B9D" strokeWidth={2} dot={false} activeDot={{
                r: 6
              }} data-id="element-107" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Conversion Rate Comparison & Balance Check */}
        <div className="space-y-6" data-id="element-108">
          {/* Conversion Bar Chart */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-109">
            <h3 className="font-semibold text-slate-800 mb-6" data-id="element-110">
              Purchase Conversion Rate
            </h3>
            <div className="h-48 w-full" data-id="element-111">
              <ResponsiveContainer width="100%" height="100%" data-id="element-112">
                <BarChart data={conversionData} margin={{
                top: 20,
                right: 0,
                left: -20,
                bottom: 0
              }} data-id="element-113">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" data-id="element-114" />
                  <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                  fill: '#64748b',
                  fontSize: 12
                }} dy={10} data-id="element-115" />
                  <YAxis axisLine={false} tickLine={false} tick={{
                  fill: '#64748b',
                  fontSize: 12
                }} tickFormatter={val => `${val}%`} data-id="element-116" />
                  <RechartsTooltip cursor={{
                  fill: '#f8fafc'
                }} contentStyle={{
                  borderRadius: '8px',
                  border: 'none',
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                }} formatter={value => [`${value}%`, 'Conversion Rate']} data-id="element-117" />
                  <Bar dataKey="rate" radius={[4, 4, 0, 0]} maxBarSize={60} data-id="element-118">
                    {conversionData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.fill} data-id="element-119" />)}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Balance Check */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-120">
            <div className="flex items-center gap-2 mb-4" data-id="element-121">
              <h3 className="font-semibold text-slate-800" data-id="element-122">
                Experiment Balance Check
              </h3>
              <Info size={14} className="text-slate-400" data-id="element-123" />
            </div>

            <div className="space-y-4" data-id="element-124">
              <div className="flex justify-between items-center text-sm" data-id="element-125">
                <div className="flex items-center gap-2" data-id="element-126">
                  <span className="w-4 h-4 rounded-full border-2 border-slate-300 flex items-center justify-center text-[9px] text-slate-500" data-id="element-127">
                    0
                  </span>
                  <span className="text-slate-600" data-id="element-128">Control</span>
                </div>
                <div className="text-right" data-id="element-129">
                  <div className="font-semibold text-slate-800" data-id="element-130">
                    475 units{' '}
                    <span className="text-slate-400 font-normal" data-id="element-131">(50%)</span>
                  </div>
                  <div className="text-xs text-slate-400" data-id="element-132">
                    Expected: 475 (50%)
                  </div>
                </div>
              </div>

              <div className="h-px w-full bg-slate-100" data-id="element-133"></div>

              <div className="flex justify-between items-center text-sm" data-id="element-134">
                <div className="flex items-center gap-2" data-id="element-135">
                  <span className="w-4 h-4 rounded-full bg-teal-100 border border-teal-300 flex items-center justify-center text-[9px] text-teal-700 font-bold" data-id="element-136">
                    1
                  </span>
                  <span className="text-slate-600" data-id="element-137">Variant</span>
                </div>
                <div className="text-right" data-id="element-138">
                  <div className="font-semibold text-slate-800" data-id="element-139">
                    475 units{' '}
                    <span className="text-slate-400 font-normal" data-id="element-140">(50%)</span>
                  </div>
                  <div className="text-xs text-slate-400" data-id="element-141">
                    Expected: 475 (50%)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}